// extracted by mini-css-extract-plugin
module.exports = {"summary":"styles_summary__FsIh1","bottomMargin":"styles_bottomMargin__Dj9AS"};